var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrengths({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.774,
    height: 15.096,
    viewBox: "0 0 29.774 15.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_828",
    "data-name": "Rectangle 828",
    width: 29.774,
    height: 15.096,
    fill: "#065683"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5376",
    "data-name": "Path 5376",
    d: "M29.349,3.265a1.729,1.729,0,0,0-1.059-.489H25.53V1.8a1.828,1.828,0,0,0-1.8-1.8H21.747a1.828,1.828,0,0,0-1.8,1.8V4.851H9.862V1.8A1.828,1.828,0,0,0,8.058,0H6.079a1.779,1.779,0,0,0-1.8,1.8V2.84H1.516A1.472,1.472,0,0,0,.063,4.291L0,10.88a1.6,1.6,0,0,0,.457,1.015,1.728,1.728,0,0,0,1.059.489h2.76v.908A1.874,1.874,0,0,0,4.8,14.575,1.775,1.775,0,0,0,6.08,15.1H8.058a1.828,1.828,0,0,0,1.8-1.8V10.182H19.943v3.111a1.875,1.875,0,0,0,.521,1.283,1.774,1.774,0,0,0,1.283.521h1.979a1.78,1.78,0,0,0,1.8-1.8v-.909H28.3a1.6,1.6,0,0,0,1.014-.456,1.5,1.5,0,0,0,.457-1.028V4.325a1.444,1.444,0,0,0-.425-1.059m-.725,7.6a.292.292,0,0,1-.3.3H25.53V3.959h2.76a.348.348,0,0,1,.217.085.252.252,0,0,1,.092.172l-.007.023Zm-7.5-9.01a.538.538,0,0,1,.146-.409.649.649,0,0,1,.476-.2h1.979a.694.694,0,0,1,.44.181.57.57,0,0,1,.181.44v1.3a.619.619,0,0,0,0,.39v9.805a.538.538,0,0,1-.146.409.648.648,0,0,1-.476.2h-1.99a.543.543,0,0,1-.409-.146.649.649,0,0,1-.2-.476ZM19.943,9H9.862V6.033H19.943ZM5.458,3.235V1.868a.6.6,0,0,1,.181-.44.691.691,0,0,1,.44-.181H8.058a.692.692,0,0,1,.44.181.572.572,0,0,1,.181.44v11.5a.537.537,0,0,1-.146.409.647.647,0,0,1-.476.2H6.069a.54.54,0,0,1-.409-.145.649.649,0,0,1-.2-.477V3.627a.62.62,0,0,0,0-.392M1.214,4.325a.293.293,0,0,1,.3-.3h2.76V11.2H1.516a.292.292,0,0,1-.3-.3Z",
    transform: "translate(0 0)",
    fill: "#065683"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengths);
export default __webpack_public_path__ + "static/media/strengths.95fc30b392b1c0ad7afbdf3c6665b9fa.svg";
export { ForwardRef as ReactComponent };